import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[ControllerColor SetFilter] Action',
  ResetFilter: '[ControllerColor ResetFilter] Action',
}

const initialControllerColorState: IControllerColorState = {
  filter: {
    active: true,
  },
}

export interface IControllerColorState {
  filter?: {
    active: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-ControllerColor', whitelist: ['filter']},
  (
    state: IControllerColorState = initialControllerColorState,
    action: ActionWithPayload<IControllerColorState>
  ) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialControllerColorState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}
